import React, {FC} from "react"

import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Tooltip} from "@irati/ui/src/Tooltip"

interface Props extends InjectIntl {
  hideText: boolean
  tooltip: string
  load: Promise<any> | null
  onClick: () => void
}

const PollsDownload: FC<Props> = ({hideText, tooltip, load, onClick, formatMessage}) => {
  return (
    <Flex justifyContent={hideText ? "flex-end" : "space-between"} alignItems="center" marginTop={1}>
      {!hideText && (
        <Label>
          <FormattedMessage id="admin.reporting.popularPerks.dataInfo" />
        </Label>
      )}
      <Tooltip tooltipChildren={formatMessage({id: tooltip})} placement="left">
        <Button id="adminSection_reporting_downloadCelebration_button" primary onClick={onClick} load={load}>
          <FormattedMessage id="admin.reporting.button.downloadReport" />
        </Button>
      </Tooltip>
    </Flex>
  )
}

export default injectIntl(PollsDownload)
